/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Overlap_LabelInputs */

const en_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlap`)
};

const fr_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chevauchement`)
};

const de_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappen`)
};

const it_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrapposizione`)
};

const ru_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перекрывать`)
};

const es_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superposición`)
};

const zh_cn2_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠`)
};

const ja_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複`)
};

const hi_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप`)
};

const pt_pt2_event_warning_overlap_label = /** @type {(inputs: Event_Warning_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobreposição`)
};

/**
* | output |
* | --- |
* | "Overlap" |
*
* @param {Event_Warning_Overlap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_overlap_label = /** @type {((inputs?: Event_Warning_Overlap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Overlap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_overlap_label(inputs)
	if (locale === "de") return de_event_warning_overlap_label(inputs)
	if (locale === "it") return it_event_warning_overlap_label(inputs)
	if (locale === "ru") return ru_event_warning_overlap_label(inputs)
	if (locale === "es") return es_event_warning_overlap_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_overlap_label(inputs)
	if (locale === "ja") return ja_event_warning_overlap_label(inputs)
	if (locale === "hi") return hi_event_warning_overlap_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_overlap_label(inputs)
	return en_event_warning_overlap_label(inputs)
});